import React from 'react';
import ToolLogo from '../ui/ToolLogo';
import { LogoSlug, RAIL_TOP, RAIL_BOTTOM } from '../../data/logos';

/** One infinitely-scrolling row. The list is duplicated so the loop is seamless. */
const Rail: React.FC<{ items: LogoSlug[]; reverse?: boolean }> = ({
  items,
  reverse = false,
}) => (
  <div className="logo-rail py-1.5">
    <div className={`logo-rail-track ${reverse ? 'reverse' : ''}`}>
      {[...items, ...items].map((slug, i) => (
        <ToolLogo key={`${slug}-${i}`} slug={slug} />
      ))}
    </div>
  </div>
);

/**
 * The "wired into" logo marquee — every platform, model and datastore that
 * shows up in the workflows further down the page.
 */
const LogoRailSection: React.FC = () => (
  <section
    aria-label="Tools and platforms I integrate"
    className="border-y border-canvas-border/50 bg-canvas-deep/40 py-8"
  >
    <div className="mb-5 flex items-center gap-3 px-1">
      <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-ink-muted">
        {'// wired into'}
      </span>
      <span className="h-px flex-1 bg-canvas-border/60" />
      <span className="font-mono text-[11px] text-ink-muted">
        {RAIL_TOP.length + RAIL_BOTTOM.length}+ platforms
      </span>
    </div>

    <Rail items={RAIL_TOP} />
    <Rail items={RAIL_BOTTOM} reverse />
  </section>
);

export default LogoRailSection;
